import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import WeatherApp from "./WeatherApp";
import "./styles.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <div className="App">
      <WeatherApp />
    </div>
  </StrictMode>
);
